import React, { useState, useEffect } from "react";
import "./skiWeather.css";
import icon1 from "../../assets/weather_symbols/1.svg";
import icon2 from "../../assets/weather_symbols/2.svg";
import icon3 from "../../assets/weather_symbols/3.svg";
import icon4 from "../../assets/weather_symbols/4.svg";
import icon5 from "../../assets/weather_symbols/5.svg";
import icon6 from "../../assets/weather_symbols/6.svg";
import icon7 from "../../assets/weather_symbols/7.svg";
import icon8 from "../../assets/weather_symbols/8.svg";
import icon9 from "../../assets/weather_symbols/9.svg";
import icon10 from "../../assets/weather_symbols/10.svg";
import icon11 from "../../assets/weather_symbols/11.svg";
import icon12 from "../../assets/weather_symbols/12.svg";
import icon13 from "../../assets/weather_symbols/13.svg";
import icon14 from "../../assets/weather_symbols/14.svg";
import icon15 from "../../assets/weather_symbols/15.svg";
import icon16 from "../../assets/weather_symbols/16.svg";
import icon17 from "../../assets/weather_symbols/17.svg";
import icon18 from "../../assets/weather_symbols/18.svg";
import icon19 from "../../assets/weather_symbols/19.svg";
import icon20 from "../../assets/weather_symbols/20.svg";
import icon21 from "../../assets/weather_symbols/21.svg";
import icon22 from "../../assets/weather_symbols/22.svg";
import icon23 from "../../assets/weather_symbols/23.svg";
import icon24 from "../../assets/weather_symbols/24.svg";
import icon25 from "../../assets/weather_symbols/25.svg";
import icon26 from "../../assets/weather_symbols/26.svg";
import icon27 from "../../assets/weather_symbols/27.svg";
import powderDay from "../../assets/weather_symbols/powder_day.svg";
import logoBarFaded from '../../assets/logo_bar_faded.svg';
import { WeatherResponse, TimeSeriesEntry, ForecastDay, RecentLocation } from '../../../interface/interface';

const skiResorts = [
    { id: "bjorli", name: "Bjorli", coords: "62.279172, 8.225848" },

    { id: "branas", name: "Branäs", coords: "60.651604, 12.953880" },

    { id: "bryngfjorden", name: "Bryngfjorden Skidbacke", coords: "59.425069, 13.459809" },

    { id: "domlebacken", name: "Dömlebacken", coords: "59.590876, 13.413869" },

    { id: "Ekesberget", name: "Ekesberget", coords: "60.167967, 13.487458" },

    { id: "fjatervalen", name: "Fjätervålen", coords: "61.935960, 12.963253" },

    { id: "frykstabacken", name: "Frykstabacken", coords: "59.528382, 13.336134" },

    { id: "galdhopiggen", name: "Galdhøpiggen Summer Ski", coords: "61.663710, 8.350473" },

    { id: "hafjell", name: "Hafjell", coords: "61.233488, 10.508420" },

    { id: "hovfjallet", name: "Hovfjället", coords: "60.292689, 12.967744" },

    { id: "klappen", name: "Kläppen", coords: "61.024209, 13.364135" },

    { id: "kvitfjell", name: "Kvitfjell", coords: "61.465152, 10.122288" },

    { id: "lindvallen", name: "Lindvallen-Sälen", coords: "61.144686, 13.185363" },

    { id: "langberget", name: "Långberget", coords: "60.817878, 12.878725" },

    { id: "myrkdalen", name: "Myrkdalen", coords: "60.862617, 6.462270" },

    { id: "narvikfjellet", name: "Narviksfjellet", coords: "68.4383,17.4272" },

    { id: "rackstadbacken", name: "Rackstadbacken", coords: "59.687516, 12.679028" },

    { id: "romme", name: "Romme Alpin", coords: "60.383643, 15.402583" },

    { id: "stoten", name: "Stöten", coords: "61.259058, 12.8760" },

    { id: "stranda", name: "Strandafjellet", coords: "62.285269, 6.823165" },

    { id: "sunne", name: "Sunne Ski & Bike", coords: "59.802389, 13.032925" },

    { id: "safsen", name: "Säfsen", coords: "60.119621, 14.421194" },

    { id: "tandadalen", name: "Tandådalen-Sälen", coords: "61.173647, 13.011661" },

    { id: "tanndalen", name: "Tänndalen", coords: "62.567136, 12.216747" },

    { id: "valfjallet", name: "Valfjället", coords: "59.826045, 12.254121" },

    { id: "vemdalen", name: "Vemdalen", coords: "62.6333,14.3075" },

    { id: "are", name: "Åre", coords: "63.4236,13.0963" },
];

const weatherIcons: Record<string, string> = {
    "1": icon1,
    "2": icon2,
    "3": icon3,
    "4": icon4,
    "5": icon5,
    "6": icon6,
    "7": icon7,
    "8": icon8,
    "9": icon9,
    "10": icon10,
    "11": icon11,
    "12": icon12,
    "13": icon13,
    "14": icon14,
    "15": icon15,
    "16": icon16,
    "17": icon17,
    "18": icon18,
    "19": icon19,
    "20": icon20,
    "21": icon21,
    "22": icon22,
    "23": icon23,
    "24": icon24,
    "25": icon25,
    "26": icon26,
    "27": icon27,
};

const SkiWeather: React.FC = () => {
    const [selectedCoords, setSelectedCoords] = useState<string>(skiResorts[0].coords);
    const [selectedName, setSelectedName] = useState<string>(skiResorts[0].name);

    const [weatherData, setWeatherData] = useState<WeatherResponse | null>(null);
    const [error, setError] = useState<string | null>(null);

    const [forecastDays, setForecastDays] = useState<ForecastDay[]>([]);
    const [recentLocations, setRecentLocations] = useState<RecentLocation[]>([]);

    useEffect(() => {
        const stored = localStorage.getItem("recentLocations");
        if (stored) {
            setRecentLocations(JSON.parse(stored));
        }
    }, []);

    const saveRecentLocation = (name: string, coords: string) => {
        const updated = recentLocations.filter((loc) => loc.coords !== coords);
        updated.push({ name, coords });
        if (updated.length > 5) {
            updated.shift();
        }
        setRecentLocations(updated);
        localStorage.setItem("recentLocations", JSON.stringify(updated));
    };

    const parseSevenDayForecast = (data: WeatherResponse): ForecastDay[] => {
        const dayMap: Record<string, TimeSeriesEntry[]> = {};
        data.timeSeries.forEach((entry: TimeSeriesEntry) => {
            const validDate = new Date(entry.time).toISOString().split("T")[0];
            if (!dayMap[validDate]) {
                dayMap[validDate] = [];
            }
            dayMap[validDate].push(entry);
        });

        const today = new Date();
        const result: ForecastDay[] = [];
        for (let i = 0; i < 7; i++) {
            const forecastDate = new Date(today);
            forecastDate.setDate(today.getDate() + i);
            const dateString = forecastDate.toISOString().split("T")[0];
            if (dayMap[dateString]) {
                result.push({ date: dateString, data: dayMap[dateString] });
            }
        }
        return result;
    };

    const fetchWeather = async (lat: number, lon: number, resortName: string) => {
        setError(null);
        setWeatherData(null);
        setForecastDays([]);

        const apiUrl = `https://opendata-download-metfcst.smhi.se/api/category/snow1g/version/1/geotype/point/lon/${lon}/lat/${lat}/data.json`;
        try {
            const response = await fetch(apiUrl);
            if (!response.ok) {
                throw new Error(`Network response not ok: ${response.statusText}`);
            }
            const data: WeatherResponse = await response.json();
            setWeatherData(data);
            const days = parseSevenDayForecast(data);
            setForecastDays(days);
            saveRecentLocation(resortName, `${lat},${lon}`);
        } catch (err) {
            setError((err as Error).message);
        }
    };

    const handleGetWeather = () => {
        const [latStr, lonStr] = selectedCoords.split(",");
        const lat = parseFloat(latStr);
        const lon = parseFloat(lonStr);
        fetchWeather(lat, lon, selectedName);
    };

    const formatDate = (dateString: string): string => {
        const dateObj = new Date(dateString);

        const weekdayShort = dateObj.toLocaleDateString('sv-SE', { weekday: 'short' });
        const weekdayMapping: { [key: string]: string } = {
            'mån': 'Mån',
            'tis': 'Tis',
            'ons': 'Ons',
            'tors': 'Tor',
            'fre': 'Fre',
            'lör': 'Lör',
            'sön': 'Sön'
        };
        const formattedWeekday = weekdayMapping[weekdayShort.toLowerCase()] || weekdayShort;

        const dayNumber = dateObj.getDate();

        const monthShort = dateObj.toLocaleDateString('sv-SE', { month: 'short' });
        const formattedMonth = monthShort.charAt(0).toUpperCase() + monthShort.slice(1);

        return `${formattedWeekday} ${dayNumber} ${formattedMonth}`;
    };


    const renderDayForecast = (day: ForecastDay) => {

        let minTemp = Infinity;
        let maxTemp = -Infinity;
        let windSum = 0;
        let windCount = 0;

        let totalPrecip = 0;
        let snowLikePrecip = 0;

        const windDirCounts: Record<number, number> = {};

        let cloudCoverSum = 0;
        let cloudCoverCount = 0;

        const weatherSymbolCounts: Record<number, number> = {};

        const precipTypeCounts: Record<number, number> = {};

        day.data.forEach((entry) => {
            const data = entry.data;

            // Temperatur
            const temp = data.air_temperature;
            if (temp < minTemp) minTemp = temp;
            if (temp > maxTemp) maxTemp = temp;

            // Check for snow-like conditions
            const snowSymbolCodes = [15, 16, 17, 25, 26, 27];

            if (
                snowSymbolCodes.includes(data.symbol_code) &&
                temp <= 0
            ) {
                snowLikePrecip += data.precipitation_amount_mean_deterministic;
            }

            // Vind
            windSum += data.wind_speed;
            windCount++;

            // Vindriktning
            const wd = data.wind_from_direction;
            windDirCounts[wd] = (windDirCounts[wd] || 0) + 1;

            // Nederbörd (mm)
            totalPrecip += data.precipitation_amount_mean_deterministic;

            // Nederbördstyp
            const precipCode = data.predominant_precipitation_type_at_surface;
            precipTypeCounts[precipCode] =
                (precipTypeCounts[precipCode] || 0) + 1;
            console.log("SMHI precipitation code:", precipCode);

            // Molntäcke
            cloudCoverSum += data.cloud_area_fraction;
            cloudCoverCount++;

            // Vädersymbol
            const symbol = data.symbol_code;
            weatherSymbolCounts[symbol] =
                (weatherSymbolCounts[symbol] || 0) + 1;
        });

        const avgWind = windCount ? (windSum / windCount).toFixed(1) : "N/A";

        const getCardinalDirection = (degree: number): string => {
            const directions = ["N", "NO", "Ö", "SO", "S", "SV", "V", "NV"];

            const index = Math.round(degree / 45) % 8;
            return directions[index];
        };

        const windDirEntries = Object.entries(windDirCounts);
        const mostCommonWindDirDegrees = windDirEntries.length > 0
            ? Number(windDirEntries.reduce((a, b) => (b[1] > a[1] ? b : a))[0])
            : null;

        const mostCommonWindDir = mostCommonWindDirDegrees !== null
            ? getCardinalDirection(mostCommonWindDirDegrees)
            : "N/A";

        const avgCloudCoverPercentage = cloudCoverCount
            ? ((cloudCoverSum / cloudCoverCount) / 8 * 100).toFixed(0)
            : "N/A";

        const precipEntries = Object.entries(precipTypeCounts);
        let precipType = "";
        if (precipEntries.length > 0) {
            const [commonPcat] = precipEntries.reduce((a, b) => (b[1] > a[1] ? b : a));

            const precipTypes: Record<string, string> = {
                "0": "Ingen nederbörd",
                "1": "Regn",
                "2": "Snöblandat regn",
                "5": "Snö / underkylt regn",
                "6": "Blandad underkyld nederbörd",
                "11": "Duggregn",
            };

            precipType = precipTypes[commonPcat] || "Okänd nederbörd";
        }
        if (!precipType) {
            precipType = totalPrecip > 0 ? "Light" : "None";
        }

        const symbolEntries = Object.entries(weatherSymbolCounts);
        const mostCommonSymbolCode = symbolEntries.length > 0
            ? symbolEntries.reduce((a, b) => (b[1] > a[1] ? b : a))[0]
            : "N/A";
        const weatherIconUrl = weatherIcons[mostCommonSymbolCode] || "";

        return (
            <>

                <div className="day-summary" key={day.date}>
                    <div className="day-header">
                        <h3 className="weather-h3">
                            {formatDate(day.date)}
                        </h3>
                    </div>

                    <img className="logoBar-faded" src={logoBarFaded} alt="logo bar" />

                    <div className="forecast-content">
                        <div className="weather-icon-container">
    {weatherIconUrl ? (
        <img
            src={weatherIconUrl}
            alt={`Väder ${mostCommonSymbolCode}`}
            className="weather-icon"
        />
    ) : (
        "N/A"
    )}
</div>
                        <p>{minTemp} °C / {maxTemp} °C</p>
                        <p>{avgWind} m/s {mostCommonWindDir}</p>
                        <p>{totalPrecip.toFixed(1)} mm {precipType}</p>
                        <p>{avgCloudCoverPercentage} % Molntäcke</p>
                    </div>

                    {snowLikePrecip >= 10 && (
                        <div className="powder-day">
                            <img
                                src={powderDay}
                                alt="Powder Day"
                                className="powder-day-icon"
                            />
                        </div>
                    )}
                </div>

            </>
        );
    };

    const renderRecentLocations = () => (
        <div id="recentLocationsContainer" className="recentlyViewed-container">
            <h3 className="weather-title">Senast besökta</h3>
            {recentLocations.map((loc, idx) => (
                <div
                    key={idx}
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                        const [latStr, lonStr] = loc.coords.split(",");
                        fetchWeather(parseFloat(latStr), parseFloat(lonStr), loc.name);
                        setSelectedCoords(loc.coords);
                        setSelectedName(loc.name);
                    }}

                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            const [latStr, lonStr] = loc.coords.split(",");
                            fetchWeather(parseFloat(latStr), parseFloat(lonStr), loc.name);
                        }
                    }}
                >
                    {loc.name}
                </div>
            ))}
        </div>
    );

    return (
        <>
            <div className="forecast-container">
                <section className="forecastLeft-container">
                    <section className="skiWeather-dsc-container">
                        <h1 className="weather-title">Skidväder</h1>
                        <p className="weather-p">
                            Med vår väderapp får du en aktuell 7-dagars väderprognos anpassad efter skidåkning. Använd drop-down menyn för att bläddra bland några skidorter i Sverige och Norge. Saknar du en skidort i listan? Skicka förslag till oss så lägger vi till det!
                        </p>
                    </section>

                    <section className="selectLocation-container">
                        <label className="locationSelect-label" htmlFor="locationSelect">Välja skidort:</label>
                        <select
                            className="select-container"
                            id="locationSelect"
                            value={selectedCoords}
                            onChange={(e) => {
                                const coords = e.target.value;
                                setSelectedCoords(coords);
                                const found = skiResorts.find((r) => r.coords === coords);
                                if (found) setSelectedName(found.name);
                            }}
                        >
                            {skiResorts.map((resort) => (
                                <option key={resort.id} value={resort.coords}>
                                    {resort.name}
                                </option>
                            ))}
                        </select>

                        <button className="getWeather-btn" id="getWeather" onClick={handleGetWeather}>
                            hämta vädret
                        </button>
                    </section>

                    {renderRecentLocations()}
                </section>

                {weatherData && (
                    <>
                        <section className="resort-title">
                            <h3 className="resort-name">{selectedName}</h3>
                        </section>

                        <section className="weatherDisplay-container" id="weatherDisplay">
                            {!error
                                ? forecastDays.map((day) => (
                                    <React.Fragment key={day.date}>
                                        {renderDayForecast(day)}
                                    </React.Fragment>
                                ))

                                : <p>Error fetching weather data: {error}</p>}
                        </section>
                    </>
                )}
            </div>

        </>
    );
};

export default SkiWeather;


